"use strict";
//(function(){
	//window.aaa = 'aaaHú';
	/*window.io = require('socket.io-client');
	// window.socket  =  io('https://websocket.worldfone.vn/worldchatbox/');
	window.socket = io.connect('https://websocketsanbox.worldfone.vn', {
                path: "/worldchatbox/socket.io/",
                reconnection: true,
                reconnectionDelay: 500,
                reconnectionDelayMax : 3000,
                reconnectionAttempts: Infinity
            });*/
	top.postMessage({get_parent_window_info: 1, data:{}}, document.referrer);
	function getLangBrowser(){
		var userLang = navigator.language || navigator.userLanguage; 

		if (userLang == null){

		}
		if (userLang = 'vi-VN') {
			userLang = 'vi';
		}else if (userLang = 'en-US') {
			userLang = 'vi';
		}

		switch(userLang) {
			case 'vi-VN':
				return 'vi';
			break;
			case 'en-US':
				return 'en';
			break;
			default:
				return 'vi';
		}

		return userLang;
	}

	function lsTest(){
		var test = 'test';
		try {
			localStorage.setItem(test, test);
			localStorage.removeItem(test);
			return true;
		} catch(e) {
			return false;
		}
	}


    	

	/*function isMobile (opts = '') {
		const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
		const notMobileRE = /CrOS/

		const tabletRE = /android|ipad|playbook|silk/i

		if (!opts) opts = {}
			let ua = opts.ua
		if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
			if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
				ua = ua.headers['user-agent']
			}
			if (typeof ua !== 'string') return false

				let result =
			(mobileRE.test(ua) && !notMobileRE.test(ua)) ||
			(!!opts.tablet && tabletRE.test(ua))
			console.log(result);
			if (
				!result &&
				opts.tablet &&
				opts.featureDetect &&
				navigator &&
				navigator.maxTouchPoints > 1 &&
				ua.indexOf('Macintosh') !== -1 &&
				ua.indexOf('Safari') !== -1
				) {
				result = true
			}
			console.log('1234');

		return result
	}
	console.log(isMobile);*/

	/*window.mobileCheck = function() {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	};

	window.mobileAndTabletCheck = function() {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	};

	function window.isMobile(){
		return true;
	}

	console.log(mobileCheck);
	console.log(mobileAndTabletCheck);*/

	// window.isMobile = function(){

	// 	/* Storing user's device details in a variable*/
 //        let details = navigator.userAgent;
  
 //        /* Creating a regular expression 
 //        containing some mobile devices keywords 
 //        to search it in details string*/
 //        let regexp = /android|iphone|kindle|ipad/i;
  
 //        /* Using test() method to search regexp in details
 //        it returns boolean value*/
 //        let isMobileDevice = regexp.test(details);
  
 //        if (isMobileDevice) {
 //            return true;
 //        } else {
 //            return false;
 //        }
 //    }
 //    console.log(isMobile());
 

        /*function generate_uuid4() {
        	var dt = new Date().getTime();
        	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        		var r = (dt + Math.random()*16)%16 | 0;
        		dt = Math.floor(dt/16);
        		return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        	});
        	return uuid;
        }
        alert(generate_uuid4());*/
        /*if(lsTest() === true){
				alert('available');
			}else{
				alert('unavailable');
			}*/

	var getUrlParameter = function getUrlParameter(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};

	/*window.vnMessage = {
		text_input: 'Nhập nội dung và ấn "Enter" để chat',
		today: 'Hôm nay',
		yesterday: 'Hôm qua',
		tomorrow: 'Ngày mai',
		sound: 'Âm thanh',
		notification : 'Thông báo',
		resolve: 'Kết thúc hội thoại',
		language: 'Ngôn ngữ',
		download_message : 'Tải xuống bản ghi',
		notification_text : 'Không bỏ lỡ bất kỳ câu trả lời nào! Cho phép thông báo?',

		title_ready_text: 'title_ready_text vn'

	};
	window.enMessage = {
		text_input: 'Type a message...',
		today: 'Today',
		yesterday: 'Yesterday',
		tomorrow: 'Tomorrow',
		sound: 'Sound',
		notification : 'Notification',
		resolve: 'Resolve conversation',
		language: 'Language',
		download_message : 'Download message',
		notification_text : 'Allow notifications and let not miss your conversation',

		title_ready_text: 'title_ready_text en'

	};*/


	window.livechat = {
		currentMes: 0,
		setting_noti:true,
		setting_sound:true,
		setting_language:'',
		languages: {
			'vi' : {
				name: 'Họ và tên',
				phone: 'Số điện thoại',
				email: 'Email',
				text_input: 'Nhập nội dung và ấn "Enter" để chat',
				today: 'Hôm nay',
				yesterday: 'Hôm qua',
				tomorrow: 'Ngày mai',
				sound: 'Âm thanh',
				notification : 'Thông báo',
				resolve: 'Kết thúc hội thoại',
				language: 'Change language',
				download_message : 'Tải xuống bản ghi',
				notification_text : 'Không bỏ lỡ bất kỳ câu trả lời nào! Cho phép thông báo?',

				title_survey_heading: 'Tư vấn trực tuyến',
				title_instruction_text: '',
				title_ready_text: 'Chat với chúng tôi',

				title_agentname_text: 'Tư vấn trực tuyến',
				title_ready_enter_text: 'Nhập nội dung',
				
				title_begin_chat: 'Start chat',

				'Danh mục chính': 'Danh mục chính',
				'Khuyến mãi': 'Khuyến mãi',

				result: 'KẾT QUẢ',
				feedback: 'Góp ý',
				share_more_reviews: 'Ý kiến đóng góp khác',
				send: 'Gửi',
				rated_message: "Đã gửi đánh giá",

				error_field_required: 'Vui lòng nhập {field}',
				error_field_length: "{field} không dài quá {length} ký tự",
				error_field_invalid: 'Giá trị trường {field} không hợp lệ',
				speech_to_text:'Chuyển giọng nói thành văn bản',
				send_a_record:'Ghi âm',
				press_to_record:'Nhấn để ghi âm',
				voice_cancel:'Xóa',
				voice_stop:'Dừng',
				voice_send:'Gửi',
			},
			'en' : {
				name: 'Your name',
				phone: 'Your phone',
				email: 'Email',
				text_input: 'Type a message...',
				today: 'Today',
				yesterday: 'Yesterday',
				tomorrow: 'Tomorrow',
				sound: 'Sound',
				notification : 'Notification',
				resolve: 'Resolve conversation',
				language: 'Change language',
				download_message : 'Download message',
				notification_text : 'Allow notifications and let not miss your conversation',

				title_survey_heading: 'Online counseling',
				title_instruction_text: 'Input survey to chat',
				title_begin_chat: 'Start chat',

				title_ready_text: 'Chat with us!',
				title_agentname_text: 'Online counseling',
				title_ready_enter_text: 'Input message and Enter to chat',

				'Danh mục chính': 'Main Menu',
				'Khuyến mãi': 'Promotion',

				result: 'RESULT',
				feedback: 'Feedback',
				share_more_reviews: 'Give additional feedback',
				send: 'SEND',
				rated_message: "Rated",

				error_field_required: '{field} is a required field',
				error_field_length: "{field} must not be greater than {length} characters long",
				error_field_invalid: '{field} is invalid',
				speech_to_text:'Speech to text',
				send_a_record:'Send a record',
				press_to_record:'Press to record',
				voice_cancel:'Cancel',
				voice_stop:'Stop',
				voice_send:'Send'
			},
			'zh-CN' : {
				name: '你的名字',
				phone: '您的手机',
				email: '电子邮件',
				text_input: '输入消息...',
				today: '今天',
				yesterday: '昨天',
				tomorrow: '明天',
				sound: '声音',
				notification : '通知',
				resolve: '解决对话',
				language: '改变语言',
				download_message : '下载留言',
				notification_text : '允许通知，不错过您的对话',

				title_survey_heading: '在线咨询',
				title_instruction_text: '输入调查问卷进行聊天',
				title_begin_chat: '开始聊天',

				title_ready_text: '与我们聊天！',
				title_agentname_text: '在线咨询',
				title_ready_enter_text: '输入消息并进入聊天',

				'Danh mục chính': '主菜单',
				'Khuyến mãi': '晋升',

				result: '结果',
				feedback: '反馈',
				share_more_reviews: '提供额外的反馈',
				send: '发送',
				rated_message: "额定",

				error_field_required: '{field} 是必填字段',
				error_field_length: "{field} 不得大于 {length} 个字符长",
				error_field_invalid: '{field} 无效',
				speech_to_text:'语音转文本',
				send_a_record:'发送记录',
				press_to_record:'按下即可录制',
				voice_cancel:'取消',
				voice_stop:'停止',
				voice_send:'发送'
			}
		},
		//surveyshow: false,
		hasUserdata:false,
		windowInfo: {},
		// checkCurrentLivechat:function(st_token){
		// 	/*var code = livechat.getId() +'|'+localStorage.getItem('st_token')+'|'+ParentWindowInfo.host;
  //   		checkCurrentLivechat('omnichat_'+btoa(code));
		// 	if (code == ) {

		// 	}*/
		// 	var key = livechat.getId() +'|'+st_token+'|'+this.windowInfo.host;
			
			
		// 	if (localStorage.getItem('omnichat_'+btoa(key)) === null) {
		// 		return false;
		// 		// localStorage.setItem('omnichat_'+btoa(key), {st_token: ''});
		// 		//console.log('sai rồi');
		// 	}else{
		// 		return true;
		// 		// console.log('ngon');
		// 	}
		// 	// console.log('omnichat_'+btoa(code));
		// 	// code = str.replace(new RegExp("omnichat_", "g"), '');
		// 	// this.windowInfo = e;
		// },		
		// setCurrentLivechatData:function(e){
		// 	/*var code = livechat.getId() +'|'+localStorage.getItem('st_token')+'|'+ParentWindowInfo.host;
  //   		checkCurrentLivechat('omnichat_'+btoa(code));
		// 	if (code == ) {

		// 	}*/
		// 	var key = livechat.getId() +'|'+localStorage.getItem('st_token')+'|'+this.windowInfo.host;
			
			
		// 	if (localStorage.getItem('omnichat_'+btoa(key)) === null) {
		// 		// return false;
		// 		// localStorage.setItem('omnichat_'+btoa(key), {st_token: ''});
		// 		//console.log('sai rồi');
		// 	}else{
		// 		// return true;
		// 		// console.log('ngon');
		// 	}
		// 	// console.log('omnichat_'+btoa(code));
		// 	// code = str.replace(new RegExp("omnichat_", "g"), '');
		// 	// this.windowInfo = e;
		// },
		addSetttinglocalStorage: function(key, item, value){
			if (localStorage.getItem(key) === null) {
				var tam = {};
				tam[item] = value;
				localStorage.setItem(key, JSON.stringify(tam));
			}else{
				var tam = JSON.parse(localStorage.getItem(key));
				tam[item] = value;
				tam = JSON.stringify(tam);
				//console.log(key,tam,item, value);
				localStorage.setItem(key, tam);

			}
		},
		getSetttinglocalStorage: function(key, item){
			if(lsTest() === true){
				if (localStorage.getItem(key) === null) {
					return null;
				}else{
					var data = JSON.parse(localStorage.getItem(key));
					if (typeof(data[item]) !== 'undefined' && typeof(data[item]) !== '') {
						return data[item];
					}else{
						return null;
					}
					

				}
			}else{
				return null;
			}
		},
		setParentWindowInfo: function(e){
			this.windowInfo = e;
		},
		setSettingSound: function(e){
			this.setting_sound = e;
			this.addSetttinglocalStorage(this.getId()+'_omnichat', 'setting_sound', e);
		},
		setSettingLanguage: function(e){
			this.setting_language = e;
			this.addSetttinglocalStorage(this.getId()+'_omnichat', 'setting_language', e);
		},
		setLanguages: function(e){			
			// this.languages = this.languages.concat(e);

			// console.log(key, value);
		},
		setLanguage: function(key, value){
			// console.log(key, value);
			// this.languages[key] = value;
			// console.log(this.languages[key]);
			// this.languages = this.languages[key].concat(value);

			/*value.forEach(element => {
				console.log(element);
			});*/
			for (var key1 in value) {
				// console.log(key1);
				// console.log(value[key1]);
				this.languages[key][key1] = value[key1];
			}

			// console.log(this.languages);
			
		},
		getLanguages: function(e){
			return this.languages;
		},
		setSettingNoti: function(e){
			// console.log(e);
			this.setting_noti = e;
			this.addSetttinglocalStorage(this.getId()+'_omnichat', 'setting_noti', e);
		},
		sethasUserdata: function(e){
			this.hasUserdata = e;
		},
		getId: function(e){
			return getUrlParameter('app_id');
		},
		
		get: function(){
			// socket.emit('getlivechat', {livechat_id:this.getId()});
		},
		validateEmail(email) {
			if (email==null || email=='') {
				return false;
			}
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			email = email.trim();
			if(re.test(String(email).toLowerCase())){
				var regex = /^[a-zA-Z0-9._-]+@(?!-)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,7}$/;
				return regex.test(String(email).toLowerCase());
			}
			return false;
		},
		validatePhone(phone) {
			var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
			return re.test(String(phone));
		},
		isEmpty(obj) {
			for(var key in obj) {
				if(obj.hasOwnProperty(key))
					return false;
			}
			return true;
		},
		init: function(){
			if(lsTest() === true){
				let key_store = this.getId()+'_omnichat';
				if (this.getSetttinglocalStorage(key_store, 'setting_sound') === null || this.getSetttinglocalStorage(key_store, 'setting_sound') == 'true' || this.getSetttinglocalStorage(key_store, 'setting_sound') == true) {
					this.setSettingSound(true);
				}else{
					this.setSettingSound(false);
				}

				// console.log(this.getSetttinglocalStorage(key_store, 'setting_noti'));
				// console.log(this.getSetttinglocalStorage(key_store, 'setting_noti') == 'false' || this.getSetttinglocalStorage(key_store, 'setting_noti') == false);
				if (/*this.getSetttinglocalStorage(key_store, 'setting_noti') === null || */this.getSetttinglocalStorage(key_store, 'setting_noti') == 'true' || this.getSetttinglocalStorage(key_store, 'setting_noti') == true) {
					this.setSettingNoti(true);
				}else if (/*this.getSetttinglocalStorage(key_store, 'setting_noti') === null || */this.getSetttinglocalStorage(key_store, 'setting_noti') == 'false' || this.getSetttinglocalStorage(key_store, 'setting_noti') === false) {
					this.setSettingNoti(false);
					// console.log(1);
				}else{
					this.setSettingNoti('');
				}

				if (this.getSetttinglocalStorage(key_store, 'setting_language') === null) {
					// console.log(this.getSetttinglocalStorage(key_store, 'setting_language'));
					// this.setSettingLanguage(this.getSetttinglocalStorage(key_store, 'setting_language'));
					
					// this.setSettingLanguage(getLangBrowser());
				}else{
					// console.log(this.getSetttinglocalStorage(key_store, 'setting_language'));
					this.setSettingLanguage(this.getSetttinglocalStorage(key_store, 'setting_language'));
				}
			}
		
		}
	}
	window.livechat.init();
	window.room = {
		room_id: '',
		init: function(e){

		},
		setRoomId: function(e){
			this.room_id = e;
		
		},
		getRoomId: function(){
			return this.room_id;
		},
		open: function(e){

		},
		close: function(e){

		},
		show: function(e){
			// emit('open_channel');
		},
		hide: function(e){

		},
	};
	window.user = {
		properties : {},
		id: '',
		name: '',
		phone: '',
		email: '',
		address: '',
		locale: '',
		get: function(e){
			// alert('ngon1');
		},
		isExists: function(e){
			// alert('ngon1');
		},
		update: function(e){
			// alert('ngon1');
		},
		setProperties: function(e){
			if (e.length>0) {
				if (this.properties.length>0) {
					this.properties = this.properties.concat(e);
					// this.properties = [this.properties, ...e];
				}else{
					this.properties = e;
				}
			}
		},
		getProperties: function(e){
			return this.properties;
		},
		setId: function(e){
			this.id = e;
		},
		setName: function(e){
			this.name = e;
		},
		setPhone: function(e){
			this.phone = e;
		},
		setEmail: function(e){
			this.email = e;
		},
		setAddress: function(e){
			this.address = e;
		},
		setMeta: function(e){
		},
		setLocale: function(e){
			this.locale = e;
		},
		setGender: function(e){
			this.gender = e;
		},
		create: function(e){
		},

	};
	window.App = {
		init: function(){

			// alert(livechat.getId());
			// livechat.get();
			
		}
	};
// 	App.init();
// })();

// alert(livechat.getId());



// console.log(window.location.protocol+'//'+window.location.hostname);
// console.log(document.URL);